export enum PresetContentType {
	XMP = "xmp",
	JSON = "json",
	CUBE = "cube",
}

export interface PresetDTO {
	presetId: string
	userId: string
	createdAt: string
	updatedAt: string
	name: string
	orderScore: number
	schemaVersion: number
	contentUrl: string
	contentType: PresetContentType
	contentDigest: string
	group?: string
	lutUrl?: string
}

export interface CreatePresetRequestDTO {
	presetId?: string
	createdAt?: Date
	name: string
	orderScore?: number
	schemaVersion: number
	contentUrl: string
	contentType: PresetContentType
	contentDigest: string
	group?: string
	lutUrl?: string
}

export interface UpdatePresetRequestDTO {
	name?: string
	orderScore?: number
	schemaVersion?: number
	contentUrl?: string
	contentType?: PresetContentType
	contentDigest?: string
	group?: string
	lutUrl?: string
}

export interface ExportedPresetDTO {
	id: string
	createdAt: Date
	updatedAt: Date
	name: string
	orderScore: number
	schemaVersion: number
	content: string
	contentType: PresetContentType
	contentDigest: string
	group?: string
	lutData?: string // base64-encoded serialized LUT data
}
